export default __webpack_public_path__ + "static/media/light-pro.396e098d.glb";